import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ScriptLoaderService } from "../../../_services/script-loader.service";
import { Helpers } from "../../../helpers";

@Component({
    selector: ".m-grid__item.m-grid__item--fluid.m-grid.m-grid--ver-desktop.m-grid--desktop.m-page__container.m-body",
    templateUrl: "./campanias.component.html",
    encapsulation: ViewEncapsulation.None,
})
export class CampaniasComponent implements OnInit {

    constructor(private _script: ScriptLoaderService) { }

    ngOnInit() {
        this._script.loadScripts('body', [
            'assets/plugins/DataTable/datatables.min.js',
            'assets/plugins/DataTable/jquery.dataTables.min.js',
            'assets/plugins/DataTable/datatables.bootstrap.js'])
            .then(result => {
                Helpers.setLoading(false);
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/theme/pages/campanias/campanias.component.ts